export const AGREEMENT_STATUS = {
  DRAFT: 'draft',
  IN_REVIEW: 'in_review',
  AWAITING_BUYER: 'awaiting_buyer',
  AWAITING_SIGN: 'awaiting_sign',
  AGREED: 'agreed',
  UPFRONT_PAID: 'upfront_paid',
  PAID: 'paid',
};
